export const gentlePhrases = [
  "Eu nunca fiquei bêbado.",
  "Eu nunca tirei comida do lixo e comi.",
  "Eu nunca peidei em público.",
  "Eu nunca viajei de avião.",
  "Eu nunca matei aula.",
  "Eu nunca menti para os meus pais.",
  "Eu nunca fiz uma aposta arriscada.",
  "Eu nunca dormi no cinema.",
  "Eu nunca chorei ou flertei para me livrar de uma multa.",
  "Eu nunca arruinei as férias de alguém.",
  "Eu nunca peguei comida ou bebida em festa e levei para casa.",
  "Eu nunca caí porque estava olhando o celular.",
  "Eu nunca tentei cortar meu cabelo e me arrependi.",
  "Eu nunca me apaixonei à primeira vista.",
  "Eu nunca deletei comentários de haters.",
  "Eu nunca disse que amo alguém sem querer ou sem sentir.",
  "Eu nunca peguei carona de estranhos.",
  "Eu nunca gostei de uma música de Justin Bieber.",
  "Eu nunca estive acordado por dois dias seguidos.",
  "Eu nunca fiz alguém ir para o hospital.",
  "Eu nunca segurei vela.",
  "Eu nunca menti minha opinião para impressionar alguém.",
  "Eu nunca usei óculos sem lentes.",
  "Eu nunca fui pego no plágio ou colando.",
  "Eu nunca tingi meu cabelo de uma cor bem forte.",
  "Eu nunca visitei um país na África.",
  "Eu nunca fiz bungee jumping.",
  "Eu nunca fiquei mais de 2 dias sem tomar banho.",
  "Eu nunca apareci em vídeo no YouTube.",
  "Eu nunca desmaiei.",
  "Eu nunca fiz piercing ou tatuagem.",
  "Eu nunca colei chiclete debaixo da mesa.",
  "Eu nunca guardei chiclete para mascar depois.",
  "Eu nunca fui expulso de um bar.",
  "Eu nunca beijei um estranho.",
  "Eu nunca disse adeus.",
  "Eu nunca comi algo escondido para não dividir.",
  "Eu nunca fingi que falava outro idioma.",
  "Eu nunca menti no currículo.",
  "Eu nunca dei calote.",
  "Eu nunca levei calote.",
  "Eu nunca peguei emprestado e não devolvi.",
  "Eu nunca vi neve.",
  "Eu nunca vi um macaco ao vivo.",
  "Eu nunca caí de moto e me ralei.",
  "Eu nunca me afoguei.",
  "Eu nunca me confessei na igreja.",
  "Eu nunca ouvi música Gospel.",
  "Eu nunca fui em um rodeio.",
  "Eu nunca fiz perguntas para Siri.",
  "Eu nunca fiquei preso no elevador.",
  "Eu nunca aprendi a andar de bicicleta.",
  "Eu nunca comecei a ver uma série só para ter assunto.",
  "Eu nunca menti que uma comida estava boa.",
  "Eu nunca usei cueca/calcinha do avesso.",
  "Eu nunca coloquei a culpa no cachorro.",
  "Eu nunca experimentei comida de cachorro.",
  "Eu nunca usei um alimento que passou da validade e depois todo mundo ficou com caganeira.",
  "Eu nunca dancei funk no meu quarto sem ninguém ver.",
  "Eu nunca treinei beijo de língua.",
  "Eu nunca cozinhei algo ruim e ofereci para me vingar da pessoa.",
  "Eu nunca colei na prova.",
  "Eu nunca subi em uma árvore.",
  "Eu nunca mostrei a bunda em público.",
  "Eu nunca procurei perguntas para brincadeira eu nunca na internet.",
  "Eu nunca dancei no palco de uma festa.",
  "Eu nunca invadi uma foto de alguém.",
  "Eu nunca tive medo de dormir sozinho.",
  "Eu nunca passei mal de tanto comer.",
  "Eu nunca cantei em público.",
  "Eu nunca fui roubado.",
  "Eu nunca ganhei um sorteio.",
  "Eu nunca brinquei de torta na cara.",
  "Eu nunca apareci na tv.",
  "Eu nunca espirrei catarro em público.",
  "Eu nunca fui perseguido por animais.",
  "Eu nunca tive uma crise de riso em um momento sério.",
  "Eu nunca misturei água na bebida para render mais.",
  "Eu nunca dei um soco em algo de vidro.",
  "Eu nunca recebi flores.",
  "Eu nunca fui à Bahia.",
  "Eu nunca quis pouco.",
  "Eu nunca tive catapora.",
  "Eu nunca pensei que eu sou a pessoa mais linda dessa roda.",
  "Eu nunca fiquei sem dormir por dois dias seguidos.",
  "Eu nunca vi um animal selvagem.",
  "Eu nunca acampei.",
  "Eu nunca fiz uma fogueira.",
  "Eu nunca voei em um balão.",
  "Eu nunca vomitei em um parque de diversões.",
  "Eu nunca cortei o meu próprio cabelo.",
  "Eu nunca invadi uma casa.",
  "Eu nunca comi língua de boi.",
  "Eu nunca planejei um discurso no banho.",
  "Eu nunca enviei fotos das minhas fezes para alguém.",
  "Eu nunca fui a um baile funk.",
  "Eu nunca fiquei com o irmão de um amigo.",
  "Eu nunca procurei o meu nome no Google.",
  "Eu nunca chorei no transporte público.",
  "Eu nunca enviei uma carta de amor.",
  "Eu nunca fui o último a ser escolhido para alguma coisa.",
  "Eu nunca li a Bíblia.",
  "Eu nunca fui a um karaokê.",
  "Eu nunca quebrei um osso.",
  "Eu nunca quebrei um dente.",
  "Eu nunca tive um cárie.",
  "Eu nunca fui a um rodeio.",
  "Eu nunca fui picado por uma abelha ou marimbondo.",
  "Eu nunca mastiguei gelo.",
  "Eu nunca comi jiló.",
  "Eu nunca fiquei de recuperação.",
  "Eu nunca joguei jogos de guerra.",
  "Eu nunca chorei em um show.",
  "Eu nunca surfei.",
  "Eu nunca mergulhei.",
  "Eu nunca vi o mar.",
  "Eu nunca vi o sol nascer.",
  "Eu nunca virei uma noite estudando.",
  "Eu nunca tive um cachorro.",
  "Eu nunca tive um gato.",
  "Eu nunca tomei injeção no bumbum.",
  "Eu nunca encontrei alguém famoso.",
  "Eu nunca fiz brincadeiras evangélicas.",
  "Eu nunca entendi uma piada e ri de mentira.",
  "Eu nunca fui queimado por uma água viva.",
  "Eu nunca participei de um programa de auditório.",
  "Eu nunca caí na balada.",
  "Eu nunca cumprimentei alguém fingindo que sabia quem era.",
  "Eu nunca pratiquei esportes.",
  "Eu nunca matei uma planta.",
  "Eu nunca levei uma ovada.",
  "Eu nunca joguei ovo em alguém.",
  "Eu nunca tive piolho.",
  "Eu nunca tive pulga.",
  "Eu nunca matei uma barata.",
  "Eu nunca engoli algo que não era de comer.",
  "Eu nunca pintei uma parede.",
  "Eu nunca apertei a campainha e saí correndo.",
  "Eu nunca perdi um voo.",
  "Eu nunca entupi uma privada e não contei para ninguém.",
  "Eu nunca fingi que não vi alguém.",
  "Eu nunca caí em uma pegadinha.",
  "Eu nunca chorei em público.",
  "Eu nunca tive infecção de urina.",
  "Eu nunca pulei a catraca para não pagar.",
  "Eu nunca menti no 'Eu Nunca'.",
  "Eu nunca pulei Carnaval.",
  "Eu nunca fiz uma viagem de carro de mais de 10 horas.",
  "Eu nunca perdi um brinquedo.",
  "Eu nunca ignorei um amigo no WhatsApp.",
  "Eu nunca tirei foto com roupas emprestadas.",
  "Eu nunca comi até passar mal.",
  "Eu nunca tive medo de ser flagrado pela polícia.",
  "Eu nunca rebolei até a boquinha da garrafa.",
  "Eu nunca caí em um golpe de internet.",
  "Eu nunca dancei axé.",
  "Eu nunca joguei coisas pela sacada ou pela janela.",
  "Eu nunca caí da cama.",
  "Eu nunca tomei na mamadeira depois de adulto.",
  "Eu nunca me deparei com um ovo podre.",
  "Eu nunca quebrei uma promessa.",
  "Eu nunca comi restos de comida da outra mesa.",
  "Eu nunca tive minhas redes sociais hackeadas.",
  "Eu nunca comi sorvete com batata frita.",
  "Eu nunca menti que estava ocupado para não sair.",
  "Eu nunca fingi que estava falando no telefone.",
  "Eu nunca parei de comer carne.",
  "Eu nunca caí em um trote.",
  "Eu nunca vi uma criatura extraterrestre.",
  "Eu nunca chamei alguém de brega.",
  "Eu nunca fiz brigadeiro.",
  "Eu nunca perdi um animal de estimação.",
  "Eu nunca dancei agarradinho.",
  "Eu nunca naveguei em um barco.",
  "Eu nunca vi o mar.",
  "Eu nunca gostei de café.",
  "Eu nunca fui chamado de feio.",
  "Eu nunca fiz uma pergunta anônima porque tinha vergonha.",
  "Eu nunca raspei o cabelo.",
  "Eu nunca plantei uma árvore.",
  "Eu nunca reciclei.",
  "Eu nunca fiz perguntas constrangedoras.",
  "Eu nunca perdi um voo.",
  "Eu nunca tomei leite azedo.",
  "Eu nunca comi pizza no café da manhã.",
  "Eu nunca tirei foto com alguém famoso.",
  "Eu nunca tive uma câmera de fotos analógica.",
  "Eu nunca fui considerado o melhor em alguma coisa",
  "Eu nunca fui considerado o pior em alguma coisa.",
  "Eu nunca falei para alguma pessoa que ela tinha cecê.",
  "Eu nunca pintei uma parede",
  "Eu nunca limpei um banheiro.",
  "Eu nunca costurei.",
  "Eu nunca fritei um ovo.",
  "Eu nunca misturei água no pote de shampoo.",
  "Eu nunca usei perguntas para eu nunca de uma lista de perguntas.",
  "Eu nunca acreditei no amor.",
  "Eu nunca fui a um parque de diversões.",
  "Eu nunca dirigi.",
  "Eu nunca acho a ponta do durex na primeira vez.",
];
